// Appkey: 6ac712a86545637cd6fd8104。Web SDK 使用与其关联的 SiteID。
const SITE_ID = "1279720400";

export function installUmengAnalytics(router) {
    if (process.env.NODE_ENV !== "production") return;
    if (window.location.hostname !== "m.wellcee.com") return;
    if (document.getElementById("umeng-uweb")) return;

    window._czc = window._czc || [];
    window._czc.push(["_setAccount", SITE_ID]);
    // 首屏也由路由回调发送；友盟后台「单页设置」需保持关闭。
    window._czc.push(["_setAutoPageview", false]);

    let lastPath;
    let referrer = document.referrer;
    router.afterEach((to, _from, failure) => {
        if (failure) return;
        // 查询参数变化计一次 PV，单纯锚点滚动不计数。
        const path = to.fullPath.split("#")[0] || "/";
        if (path === lastPath) return;

        window._czc.push(["_trackPageview", path, referrer]);
        lastPath = path;
        referrer = `${window.location.origin}${path}`;
    });

    const script = document.createElement("script");
    script.id = "umeng-uweb";
    script.async = true;
    script.src = `https://v1.cnzz.com/z.js?id=${SITE_ID}&async=1`;
    document.head.appendChild(script);
}
